<template>

<div class="family" v-on:click="onClick" :class="{'is-moving': isMoving, 'is-selected': isSelected}">

    <div class="family-info">

        <div class="family-name">
        
            {{ family.name }}

        </div>
    
        <div class="family-tags">
        
            <div class="family-tags-item is-private" v-if="!family.public">Private</div>
        
            <div class="family-tags-item is-collection" v-if="family.context === 1">Collection</div>

            <div class="family-tags-item is-ratings" v-if="family.context === 2">Ratings</div>

            <div class="family-tags-item is-plays" v-if="family.context === 3">Plays</div>
        
        </div>
    
    </div>
    
    <div class="family-icon" v-if="!isMoving">
        <i class="fa-solid fa-tags"></i> 
        <span class="family-count">{{ tagCount }}</span>
    </div>

    <div class="family-color" :style="{backgroundColor: (family.style) ? family.colour : false, color: (family.style) ? family.fore : false}">

        {{ family.attachments }}

    </div>

</div>

</template>

<script>

export default {

	props: ['family', 'isMoving', 'isSelected'],

    computed: {

        tagCount: function() {

            return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return tag.family === this.family.id

			}.bind(this)).length

        }

    },

    methods: {

        onClick: function() {

            if (this.isMoving) {

                this.$emit('click', this.family.id)

            } else {

                this.$pubsub.$emit('open.modal', {
                    id: 'tagFamilyManage',
                    family: this.family.id
                })

            }

        }

    }

}

</script>

<style scoped>

.family {
    padding: 10px 20px 10px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    cursor: pointer;
    display: grid;
	user-select: none;
    grid-gap: 10px;
    grid-template-columns: 1fr 40px 40px;
    align-items: center;
}

.family.is-moving {
    grid-template-columns: 1fr 40px;
}

.is-mobile .family {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.family:not(.is-selected):hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-bottom: 1px solid transparent;
}

.family.is-selected {
    background-color: rgba(0, 0, 0, 0.15);
    border-bottom: 1px solid transparent;
}

.family-color {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    line-height: 40px;
    background-color: #133445;
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
}

.family-name {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
}

.is-mobile .family-name {
    color: #343434;
}

.family-name span {
    opacity: 0.5;
    font-size: 14px;
}

.family-icon {
    text-align: center;
    line-height: 44px;
    text-align: center;
    height: 40px;
    background-color: #587685;
    border-radius: 4px;
}

.family-icon i {
    font-size: 18px;
    color: #fff;
}

.family-count {
    position: absolute;
    border: 2px solid #2b5870;
    box-sizing: border-box;
    font-size: 12px;
    color: #fff;
    background-color: #133445;
    border-radius: 8px;
    height: 20px;
    min-width: 20px;
    line-height: 16px;
    text-align: center;
    right: -8px;
    top: -8px;
    font-weight: 500;
}

.family:hover .family-count {
    border-color: #608294;
}

.family-tags {
    display: flex;
    gap: 4px;
    margin-top: 3px;
}

.family-tags-item {
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 12px;
    font-weight: 400;
    text-transform: lowercase;
    color: #0a2b3d;
    background-color: rgba(255, 255, 255, 0.25);
}

.is-mobile .family-tags-item {
    background-color: rgba(0, 0, 0, 0.25);
}

.family-metric {
    color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 32px;
}

.family-metric-value {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 1px;
}

.family-metric-label {
    font-size: 12px;
    font-weight: 400;
    opacity: 0.6;
}

</style>